import api from './axios'

// 단어 전체 조회
export const getWordList = async() => {
  const res = await api.get("/word-records/child")
  return res.data
}

// 단어 개별 조회
export const getWord = async(id) => {
  const res = await api.get(`word-records/${id}`)
  return res.data
}

// 음성 파일 전송(짧은 단어, 카드 단어)
export const uploadAudio = async(formData) => {
  const res = await api.post("word-records/transcribe", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return res.data
};

// 발화내용 텍스트 전송(짧은 단어)
export const uploadText = async(data) => {
   const res = await api.post("word-records/transcribe-text", data);
   return res.data
}

// 단어 등록
export const createWord = async(formData) => {
  const res = await api.post("word-records/create", formData, {
    headers: {"Content-Type": "multipart/form-data"}
  });
  return res.data
};

// 카드 단어 등록
export const createCardWord = async(formData) => {
  const res = await api.post("word-records/create-AAC", formData, {
    headers: {"Content-Type": "multipart/form-data"}
  });
  return res.data
};

// 단어 수정
export const updateWord = async(id, data) => {
  const res = await api.patch(`word-records/${id}/meaning`, data);
  return res.data
}

// 단어 삭제
export const deleteWord = async(id) => {
  await api.delete(`word-records/${id}`, id)
}

// 단어 검색
export const searchWord = async(data) => {
  const res = await api.get("word-records/search", {
    params: data
  });
  return res.data
}